
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global.mapHelper = factory());
}(this, (function () {
    'use strict';

    var red = 42, green = 130, blue = 220;
    const R = 6371;
    const COLOR = {
        'nd': 'blue',
        'tk': 'green',
        'dl': 'red',
        'accent': 'orange',
        'active': 'blue'
    }

    var icon = {
        strokeWeight: 1,
        strokeColor: 'white',
        scale: 1,
        labelOrigin: new google.maps.Point(14, 11)
    }

    function _generateInfoWindow(point) {
        let { routes, dlboys } = window.mapComponent ? window.mapComponent.get() : { routes: null, dlboys: null };

        let content = '<div>';
        if (point.orders[0]) {
            content += '<div class="uk-grid-small" uk-grid>';

            if (point.type == 'tk') content += '<div class="uk-width-expand uk-text-takeout">Забор ' + point.orders[0] + '</div>';
            if (point.type == 'dl') content += '<div class="uk-width-expand uk-text-takeout">Доставка ' + point.orders[0] + '</div>';

            content += '<div class="status ' + point.application.status.key + '">'
                + point.application.status.value
                + '</div>'
                + '</div>';
        }

        if (point.application.client) {
            content += '<div class="uk-grid-small" uk-grid>'
                + '<div class="uk-width-expand uk-text-small uk-text-muted">Контактное лицо:</div>'
                + '<div>'
                + point.application.client.name
                + '</div>'
                + '</div>';

            if (point.application.client.phone) {
                content += '<div class="uk-grid-small" uk-grid>'
                    + '<div class="uk-width-expand uk-text-small uk-text-muted">Телефон:</div>'
                    + '<div>'
                    + point.application.client.phone
                    + '</div>'
                    + '</div>';
            }
        }

        if (point.application.legal) {
            content += '<div class="uk-grid-small" uk-grid>'
                + '<div class="uk-width-expand uk-text-small uk-text-muted">Юр.лицо:</div>'
                + '<div>'
                + point.application.legal.short_name
                + '</div>'
                + '</div>';
        }

        if (point.orders[0]) {
            content += '<div class="uk-grid-small" uk-grid>'
                + '<div class="uk-width-expand uk-text-small uk-text-muted">Тип оплаты:</div>'
                + '<div>Предоплата частичная</div>'
                + '</div>';
        }

        if (point.application.date_start && point.application.date_end) {
            content += '<div class="uk-grid-small" uk-grid>'
                + '<div class="uk-width-expand">Дата и время доставки:</div>'
                + '<div>'
                + moment(point.application.date_start).format('DD.MM HH:mm')
                + ' - '
                + moment(point.application.date_end).format('DD.MM HH:mm')
                + '</div>'
                + '</div>';
        }

        content += '<hr/>';

        if(routes || dlboys) content += '<div class="uk-margin">'
            + '<label class="uk-form-label" for="form-stacked-select">Маршрут</label>'
            + '<div class="uk-form-controls">'
            + '<select class="uk-select uk-form-small" id="form-stacked-select" onchange="window.mapComponent.setRoute(this.value); window.map.helper.closeInfoWindow();">'
            + '<option selected="selected">Не назначен</option>';

        if(routes) routes.map(route => {
            content += '<option value="' + point.id + '#routes#' + route.id;
            if (point.application) {
                content += '#' + point.application.id;
                content += '#' + point.application.date_start;
            }
            content += '" ';
            ////console.log(route.applications_ids);
            ////console.log(point.application.id);
            if (route.applications_ids.includes(point.application.id)) {
                content += 'selected="selected"';
            }
            content += '>' + route.name;
            if (route.dlboy) content += ' (' + route.dlboy.last_name + ')';
            content += '</option>';
        });

        if(dlboys) dlboys.map(dlboy => {
            content += '<option value="' + point.id + '#users#' + dlboy.id;
            if (point.application) {
                content += '#' + point.application.id;
                content += '#' + point.application.date_start;
            }
            content += '">' + dlboy.last_name + '</option>';
        });

        if(routes || dlboys) content += '</select>'
            + '</div>'
            + '</div>'
            + '<hr/>';

        if (point.application.products && point.application.products.length > 0) {
            content += '<table class="uk-table">'
                + '<caption>Товарные позиции:</caption>'
                + '<thead>'
                + '<tr>'
                + '<th>Артикул</th>'
                + '<th>Наименование</th>'
                + '<th>Кол-во</th>'
                + '<th>Сумма</th>'
                + '</tr>'
                + '</thead>'
                + '</tbody>';

            point.application.products.map(product => {
                content += '<tr>'
                    + '<td>' + product.article + '</td>'
                    + '<td>' + product.name + '</td>'
                    + '<td>' + product.count + '</td>'
                    + '<td>' + (product.price * product.count) + '</td>'
                    + '</tr>';
            });

            content += '</tbody>'
                + '</table>';
        }

        content += '</div>';

        return content;
    }

    function _generateClusterIcon(ratio = 1) {
        return 'data:image/svg+xml;base64,' + window.btoa('<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" version="1.1"><circle cx="15" cy="15" r="13.5" stroke="red" stroke-width="3" fill="white"></circle><circle cx="15" cy="15" r="13.5" stroke="darkgreen" stroke-dasharray="' + ratio * 86 + ', 1000" stroke-width="3" fill="transparent"></circle></svg>');
    }

    function _generateIcon(fillColor, point, info = null) {
        let icon = {};

        info = {};
        info.show = [];

        if(window.markerInfoKeys){

            if (window.markerInfoKeys.time && point.application) {
                let temp = "";
                if (point.application) {
                    temp += moment(point.application.date_start).format('HH:mm');
                    temp += ' - ';
                    temp += moment(point.application.date_end).format('HH:mm');
                }
                info.show.push(temp);
            }

            if (window.markerInfoKeys.WHD && point.application) {
                let temp = "";
                if (point.application) {
                    temp += '1200x80x140';
                }
                info.show.push(temp);
            }

            if (window.markerInfoKeys.weight && point.application && point.application.products && point.application.products.length > 0) {
                let temp = 0;
                point.application.products.map(item => {
                    temp += parseFloat(item.weight) * parseInt(item.count);
                });
                temp += 'кг';

                info.show.push(temp);
            }

            if (window.markerInfoKeys.legals && point.legals) {
                let temp = "";
                if (point.legals) {
                    temp += point.legals[0];
                }
                info.show.push(temp);
            }
        }

        if (info.show.length > 0) {

            if (info.show.length == 1) {
                icon.anchor = new google.maps.Point(15, 39);
                icon.labelOrigin = new google.maps.Point(14, 21);
                info.type = 'small';
            }

            if (info.show.length > 1 && info.show.length <= 3) {
                icon.anchor = new google.maps.Point(15, 51);
                icon.labelOrigin = new google.maps.Point(14, 33);
                info.type = 'medium';
            }

        } else {
            icon.labelOrigin = new google.maps.Point(14, 11);
        }

        if (info && info.show.length > 0) {
            if (info.type == 'small') {
                if (!info.width) {
                    info.width = 139;
                }

                icon.url = "data:image/svg+xml,%3Csvg%20width%3D%22155%22%20height%3D%2250%22%20viewBox%3D%220%200%20155%2050%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23filter0_d)%22%3E%0A%3Crect%20x%3D%2229%22%20y%3D%2213%22%20width%3D%22113%22%20height%3D%2224%22%20rx%3D%225%22%20fill%3D%22white%22%2F%3E%0A%3Ctext%20x%3D%2239%22%20y%3D%2229%22%20font-size%3D%2212%22%20fill%3D%22black%22%3E" + info.show[0] + "%3C%2Ftext%3E%0A%3C%2Fg%3E%0A%3Cpath%20d%3D%22M14.3693%2010C8.57812%2010%203.86664%2014.7115%203.86664%2020.5026C3.86664%2027.6897%2013.2655%2038.2406%2013.6657%2038.6863C14.0416%2039.1049%2014.6978%2039.1042%2015.073%2038.6863C15.4732%2038.2406%2024.872%2027.6897%2024.872%2020.5026C24.8719%2014.7115%2020.1605%2010%2014.3693%2010ZM14.3693%2025.7868C11.4556%2025.7868%209.08522%2023.4164%209.08522%2020.5026C9.08522%2017.5889%2011.4557%2015.2185%2014.3693%2015.2185C17.283%2015.2185%2019.6534%2017.589%2019.6534%2020.5027C19.6534%2023.4164%2017.283%2025.7868%2014.3693%2025.7868Z%22%20fill%3D%22" + fillColor + "%22%2F%3E%0A%3Ccircle%20cx%3D%2214.5%22%20cy%3D%2220.6334%22%20r%3D%228.7%22%20fill%3D%22white%22%2F%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22filter0_d%22%20x%3D%2216%22%20y%3D%220%22%20width%3D%22" + info.width + "%22%20height%3D%2250%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%0A%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%0A%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%2F%3E%0A%3CfeOffset%2F%3E%0A%3CfeGaussianBlur%20stdDeviation%3D%226.5%22%2F%3E%0A%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200.321569%200%200%200%200%200.247059%200%200%200%200%200.411765%200%200%200%200.05%200%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow%22%20result%3D%22shape%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E%0A";
            }

            if (info.type == 'medium') {
                let second = '';
                let third = '';

                if (!info.width) {
                    info.width = 139;
                }

                if (info.show[1]) {
                    second = '%3Ctext%20x%3D%2239%22%20y%3D%2245%22%20font-size%3D%2212%22%20font-family%3D%22Roboto%22%20fill%3D%22%23C4C4C4%22%3E' + info.show[1] + '%3C%2Ftext%3E';
                }

                if (info.show[2]) {
                    third = '%3Ctext%20x%3D%22113%22%20y%3D%2245%22%20font-size%3D%2212%22%20font-family%3D%22Roboto%22%20fill%3D%22%23C4C4C4%22%3E' + info.show[2] + '%3C%2Ftext%3E';
                }

                icon.url = "data:image/svg+xml,%3Csvg%20width%3D%22155%22%20height%3D%2269%22%20viewBox%3D%220%200%20155%2069%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M14.3693%2022C8.57812%2022%203.86664%2026.7115%203.86664%2032.5026C3.86664%2039.6897%2013.2655%2050.2406%2013.6657%2050.6863C14.0416%2051.1049%2014.6978%2051.1042%2015.073%2050.6863C15.4732%2050.2406%2024.872%2039.6897%2024.872%2032.5026C24.8719%2026.7115%2020.1605%2022%2014.3693%2022ZM14.3693%2037.7868C11.4556%2037.7868%209.08522%2035.4164%209.08522%2032.5026C9.08522%2029.5889%2011.4557%2027.2185%2014.3693%2027.2185C17.283%2027.2185%2019.6534%2029.589%2019.6534%2032.5027C19.6534%2035.4164%2017.283%2037.7868%2014.3693%2037.7868Z%22%20fill%3D%22" + fillColor + "%22%2F%3E%0A%3Ccircle%20cx%3D%2214.5%22%20cy%3D%2232.6334%22%20r%3D%228.7%22%20fill%3D%22white%22%2F%3E%0A%3Cg%20filter%3D%22url(%23filter0_d)%22%3E%0A%3Crect%20x%3D%2229%22%20y%3D%2213%22%20width%3D%22113%22%20height%3D%2243%22%20rx%3D%225%22%20fill%3D%22white%22%2F%3E%0A%3Ctext%20x%3D%2239%22%20y%3D%2229%22%20font-size%3D%2212%22%20font-family%3D%22Roboto%22%20fill%3D%22%23515151%22%3E" + info.show[0] + "%3C%2Ftext%3E%0A" + second + third + "%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22filter0_d%22%20x%3D%2216%22%20y%3D%220%22%20width%3D%22139%22%20height%3D%2269%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%0A%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%0A%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%2F%3E%0A%3CfeOffset%2F%3E%0A%3CfeGaussianBlur%20stdDeviation%3D%226.5%22%2F%3E%0A%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200.321569%200%200%200%200%200.247059%200%200%200%200%200.411765%200%200%200%200.05%200%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow%22%20result%3D%22shape%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E%0A";
            }
        } else {
            icon.url = "data:image/svg+xml,%3Csvg width='29' height='29' viewBox='0 0 29 29' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.3694 0C8.57818 0 3.8667 4.71148 3.8667 10.5026C3.8667 17.6897 13.2656 28.2406 13.6658 28.6863C14.0416 29.1049 14.6979 29.1042 15.073 28.6863C15.4732 28.2406 24.8721 17.6897 24.8721 10.5026C24.872 4.71148 20.1606 0 14.3694 0ZM14.3694 15.7868C11.4557 15.7868 9.08528 13.4164 9.08528 10.5026C9.08528 7.58894 11.4558 5.21853 14.3694 5.21853C17.2831 5.21853 19.6535 7.58899 19.6535 10.5027C19.6535 13.4164 17.2831 15.7868 14.3694 15.7868Z' fill='" + fillColor + "'/%3E%3Ccircle cx='14.5' cy='10.6331' r='8.7' fill='white'/%3E%3C/svg%3E";
        }
        // return "data:image/svg+xml,%3Csvg%20width%3D%22155%22%20height%3D%2269%22%20viewBox%3D%220%200%20155%2069%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M14.3693%2022C8.57812%2022%203.86664%2026.7115%203.86664%2032.5026C3.86664%2039.6897%2013.2655%2050.2406%2013.6657%2050.6863C14.0416%2051.1049%2014.6978%2051.1042%2015.073%2050.6863C15.4732%2050.2406%2024.872%2039.6897%2024.872%2032.5026C24.8719%2026.7115%2020.1605%2022%2014.3693%2022ZM14.3693%2037.7868C11.4556%2037.7868%209.08522%2035.4164%209.08522%2032.5026C9.08522%2029.5889%2011.4557%2027.2185%2014.3693%2027.2185C17.283%2027.2185%2019.6534%2029.589%2019.6534%2032.5027C19.6534%2035.4164%2017.283%2037.7868%2014.3693%2037.7868Z%22%20fill%3D%22" +fillColor+ "%22%2F%3E%0A%3Ccircle%20cx%3D%2214.5%22%20cy%3D%2232.6334%22%20r%3D%228.7%22%20fill%3D%22white%22%2F%3E%0A%3Cg%20filter%3D%22url(%23filter0_d)%22%3E%0A%3Crect%20x%3D%22"+infoWindow.x+"%22%20y%3D%22"+infoWindow.y+"%22%20width%3D%22"+infoWindow.width+"%22%20height%3D%22"+infoWindow.height+"%22%20rx%3D%225%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22filter0_d%22%20x%3D%2216%22%20y%3D%220%22%20width%3D%22139%22%20height%3D%2269%22%20filterUnits%3D%22userSpaceOnUse%22%20color-interpolation-filters%3D%22sRGB%22%3E%0A%3CfeFlood%20flood-opacity%3D%220%22%20result%3D%22BackgroundImageFix%22%2F%3E%0A%3CfeColorMatrix%20in%3D%22SourceAlpha%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200%22%2F%3E%0A%3CfeOffset%2F%3E%0A%3CfeGaussianBlur%20stdDeviation%3D%226.5%22%2F%3E%0A%3CfeColorMatrix%20type%3D%22matrix%22%20values%3D%220%200%200%200%200.321569%200%200%200%200%200.247059%200%200%200%200%200.411765%200%200%200%200.05%200%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in2%3D%22BackgroundImageFix%22%20result%3D%22effect1_dropShadow%22%2F%3E%0A%3CfeBlend%20mode%3D%22normal%22%20in%3D%22SourceGraphic%22%20in2%3D%22effect1_dropShadow%22%20result%3D%22shape%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E%0A";


        return icon;
    }

    function _calcCrow(lat1, lon1, lat2, lon2) {
        var dLat = _toRad(lat2 - lat1);
        var dLon = _toRad(lon2 - lon1);
        var lat1 = _toRad(lat1);
        var lat2 = _toRad(lat2);

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        return d;
    }

    // Converts numeric degrees to radians
    function _toRad(Value) {
        return Value * Math.PI / 180;
    }

    var glOffset = 268435456;
    var glRadius = 85445659.4471;// offset / pi

    function _lonToX(lon) {
        var p = Math.PI / 180;
        var b = glRadius * lon;
        var c = b * p;
        return Math.round(glOffset + c);
    }

    function _XtoLon(x) {
        return -180 + 0.0000006705522537 * x;
    }

    function _latToY(lat) {
        return Math.round(glOffset - glRadius *
            Math.log((1 + Math.sin(lat * Math.PI / 180)) /
                (1 - Math.sin(lat * Math.PI / 180))) / 2);
    }

    function _YtoLat(y) {
        var e = 2.7182818284590452353602875;
        var a = 268435456;
        var b = 85445659.4471;
        var c = 0.017453292519943;

        return Math.asin(Math.pow(e, (2 * a / b - 2 * y / b)) / (Math.pow(e, (2 * a / b - 2 * y / b)) + 1) - 1 / (Math.pow(e, (2 * a / b - 2 * y / b)) + 1)) / c;
    }

    function rand(min, max) {
        return Math.random() * (max - min) + min;
    }

    const mapHelper = {
        markers: null,
        map: null,
        activePoint: null,
        colorScheme: new Map(),

        init({ googleMap, markers, polylines }, options) {
            const self = this;

            if (googleMap) this.map = googleMap;
            this.gds = new google.maps.DirectionsService();
            this.gdr = new google.maps.DirectionsRenderer({
                map: this.map,
                suppressMarkers: true,
            });

            // this.drawManager = new google.maps.drawing.DrawingManager({
            //     drawingMode: google.maps.drawing.OverlayType.POLYGONE,
            //     drawingControl: true,
            //     drawingControlOptions: {
            //       position: google.maps.ControlPosition.TOP_CENTER,
            //       drawingModes: ['polygon']
            //     }
            // });
            // this.drawManager.setMap(this.map);

            this.iw = new google.maps.InfoWindow();
            this.geocoder = new google.maps.Geocoder();
            this.routeLegs = new Map();
            this.gdr.setMap(this.map);
            this.zIndex = 1;

            if (markers) this.markers = markers;
            if (!options || options.clusterize) {
                this.markerCluster = new MarkerClusterer(this.map, [], {
                    styles: [{
                        url: _generateClusterIcon(),
                        width: 30,
                        height: 30,
                        fontFamily: "comic sans ms",
                        textSize: 13,
                        textColor: "black",
                        //color: #00FF00,
                    }],
                    zoomOnClick: false
                });

                googleMap.addListener('idle', function () {
                    self.markerCluster.clusters_.map(cluster => {
                        let tk = 0;
                        let dl = 0;

                        cluster.markers_.map(marker => {
                            if (marker.type == 'dl') {
                                dl++;
                            } else {
                                tk++;
                            }
                        });

                        cluster.clusterIcon_.styles_[0].url = _generateClusterIcon(tk / (dl + tk));
                        cluster.updateIcon();
                    });
                });

                google.maps.event.addListener(this.markerCluster, 'clusterclick', function (cluster) {
                    let tempMarker = new google.maps.Marker({
                        map: self.map,
                        position: cluster.center_
                    });
                    tempMarker.setVisible(false);

                    let points = cluster.markers_.map(function (el) {
                        return el.point;
                    });

                    let content = '<ul uk-accordion>';
                    points.map(point => {
                        content += '<li>';
                        if (point.type == 'tk') content += '<a class="uk-accordion-title" href="#">Забор ' + point.orders[0] + '</a>';
                        if (point.type == 'dl') content += '<a class="uk-accordion-title" href="#">Доставка ' + point.orders[0] + '</a>';
                        content += '<div class="uk-accordion-content">';
                        content += _generateInfoWindow(point);
                        content += '</div>';
                        content += '</li>';
                    });

                    content += '</ul>';

                    self.iw.setContent(content);
                    self.iw.open(self.map, tempMarker);
                });
            } else {
                this.markerCluster = null;
            }

            if (polylines) this.polylines = polylines;
        },
        initGeocoder(){
            this.geocoder = new google.maps.Geocoder();
        },
        destroy() {
            this.routeLegs.clear();
            this.polylines.clear();
        },
        setMap(map) {
            this.map = map;
        },
        setMarkers(markers) {
            this.markers = markers;
        },
        refreshIcon(point) {
            if(!point.type) point.type = 'nd';
            icon = _generateIcon(COLOR[point.type], point);

            let marker = this.markers.get(point);
            if (marker) marker.setIcon(icon);
        },
        refreshAllIcons(points) {
            const self = this;

            if(points){ 
                points.map(item => {
                    this.refreshIcon(item);
                })
            } else if(this.markerCluster){
                this.markerCluster.clusters_.map(cluster => {
                    cluster.markers_.map(marker => {
                        this.refreshIcon(marker.point);
                    });
                });
            } else if(this.markers) {
                Array.from(this.markers).map(marker => {
                    this.refreshIcon(marker[0]);
                })
            }
        },
        clearPolylines(points) {
            if (this.polylines) {
                if (!points) {
                    this.polylines.forEach(polyline => {
                        ////console.log(polyline);
                        if (polyline) polyline.setMap(null);
                    });

                    this.polylines.clear();
                } else {
                    points.map(p => {
                        if (p.polylines && p.polylines_names) {
                            p.polylines.map((polyline, index) => {
                                this.hidePolyline(p.polylines_names[index]);
                            })
                        }
                    });
                }
            }
        },
        setLabel(point) {
            let marker = this.markers.get(point);
            if (marker) marker.setLabel(point.index.toString());
        },
        refreshLabels(points) {
            points.map(item => {
                this.setLabel(item);
            })
        },
        hideOnMap(point) {
            let marker = this.markers.get(point);
            if (marker) {
                marker.setMap(null);
                if(this.markerCluster) this.markerCluster.removeMarker(marker);

                if (point.polylines && point.polylines_names) {
                    point.polylines.map((polyline, index) => {
                        this.hidePolyline(point.polylines_names[index]);
                    })
                }
            }
        },
        setPosition(point) {
            let marker = this.markers.get(point);

            if (marker) {
                marker.setPosition({
                    lat: point.lat,
                    lng: point.lon
                });
            }
        },
        removeDraggable(points) {
            points.map(item => {
                let marker = this.markers.get(item);
                if (marker) marker.setDraggable(false);
            })
        },
        setDraggable(points) {
            points.map(item => {
                let marker = this.markers.get(item);
                if (marker) marker.setDraggable(true);
            })
        },
        addPolyline(p1, p2) {

        },
        setListener(point, func, component, action) {
            let marker = this.markers.get(point);
            if (marker) {
                google.maps.event.addListener(marker, action, function (event) {
                    func(point, event, component, marker);
                });
            }
        },
        setListenerToPoints(points, func, component, action = 'click') {
            points.map(item => {
                this.setListener(item, func, component, action);
            })
        },
        clearInstanceListeners(point, iw = false) {
            const self = this;
            
            let marker = this.markers.get(point);
            if (marker) {
                google.maps.event.clearInstanceListeners(marker);
                if(iw) marker.addListener('rightclick', function () {
                    let content = _generateInfoWindow(point);

                    self.iw.setContent(content);
                    self.iw.open(self.map, marker);
                });
            }
        },
        clearAllInstanceListeners(points) {
            points.map(item => {
                this.clearInstanceListeners(item);
            })
        },
        setPolyline(id, path) {
            let polyline = this.polylines.get(id);
            if (!polyline) {
                polyline = new google.maps.Polyline({
                    map: this.map,
                    path: path,
                    geodesic: true,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 1
                });

                this.polylines.set(id, polyline);
            } else {
                if (path) polyline.setPath(path);
                polyline.setMap(this.map);
            }
        },
        hidePolyline(id) {
            let polyline = this.polylines.get(id);
            if (polyline) polyline.setMap(null);
        },
        showOnMap(point, withoutInfo = false) {
            const self = this;


            if (point.type) {
                icon = _generateIcon(COLOR[point.type], point);
            } else {
                icon = _generateIcon(COLOR['nd'], point);
            }



            if (!this.markers.get(point)) {
                let marker = new google.maps.Marker({
                    position: { lat: parseFloat(point.lat), lng: parseFloat(point.lon) },
                    draggable: false,
                    icon: icon,
                    label: {
                        text: point.index.toString(),
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: 'black'
                    },
                    title: point.address,
                    type: point.type,
                    point: point
                });

                if (point.application && point.orders && point.orders.length == 1) {

                    if (!withoutInfo) {
                        marker.addListener('click', function () {
                            let content = _generateInfoWindow(point);

                            self.iw.setContent(content);
                            self.iw.open(self.map, marker);
                        });
                    }

                    marker.addListener('mouseover', function () {
                        marker.setZIndex(++self.zIndex);
                    });

                    marker.addListener('mouseout', function () {
                        marker.setZIndex(self.zIndex - 1);
                    });

                }

                this.markers.set(point, marker);

                //console.log(point.polyline);

                if (point.polylines && point.polylines_names) {
                    point.polylines.map((polyline, index) => {
                        this.setPolyline(point.polylines_names[index], [{
                            lat: parseFloat(polyline[0].lat),
                            lng: parseFloat(polyline[0].lng)
                        }, {
                            lat: parseFloat(polyline[1].lat),
                            lng: parseFloat(polyline[1].lng)
                        }]);
                    })
                }

                if(this.markerCluster) {
                    this.markerCluster.addMarker(marker);
                    this.markerCluster.clusters_.map(cluster => {
                        let tk = 0;
                        let dl = 0;

                        cluster.markers_.map(marker => {
                            if (marker.type == 'dl') {
                                dl++;
                            } else {
                                tk++;
                            }
                        });

                        cluster.clusterIcon_.styles_[0].url = _generateClusterIcon(tk / (dl + tk));
                        cluster.updateIcon();
                    });
                } else {
                    marker.setMap(this.map);
                }
            } else {
                setTimeout(() => {
                    let marker = this.markers.get(point);
                    marker.setMap(this.map);
                    if(this.markerCluster) this.markerCluster.addMarker(marker);

                    //console.log(point.polyline);

                    if (point.polylines && point.polylines_names) {
                        point.polylines.map((polyline, index) => {
                            this.setPolyline(point.polylines_names[index], [{
                                lat: parseFloat(polyline[0].lat),
                                lng: parseFloat(polyline[0].lng)
                            }, {
                                lat: parseFloat(polyline[1].lat),
                                lng: parseFloat(polyline[1].lng)
                            }]);
                        })
                    }
                }, 50);
            }


        },
        showAll(points) {
            points.map(item => {
                this.showOnMap(item);
            })
        },
        hideAll(points) {
            if (points) {
                points.map(item => {
                    this.hideOnMap(item);
                })
            } else {
                this.hideAllRoutes();
                this.clearPolylines();
            }
        },
        accent(point) {
            icon = _generateIcon(COLOR['accent'], point);
            let marker = this.markers.get(point);
            if (marker) {
                marker.setIcon(icon);
            }
        },
        refreshAccent(point) {
            if (point.type) {
                icon = _generateIcon(COLOR[point.type], point);
            } else {
                icon = _generateIcon(COLOR['nd'], point);
            }

            let marker = this.markers.get(point);
            if (marker) {
                marker.setIcon(icon);
            }
        },
        setActive(point) {
            icon = _generateIcon(COLOR['active'], point);
            let marker = this.markers.get(point);
            if (marker) {
                marker.setIcon(icon);
                this.activePoint = point;
            }
        },
        getActive() {
            return this.activePoint;
        },
        removeActive() {
            if (this.activePoint) {
                icon = _generateIcon(COLOR[this.activePoint.type], point);
                let marker = this.markers.get(this.activePoint);
                if (marker) {
                    marker.setIcon(icon);
                    this.activePoint = null;
                }
            }
        },
        hideAllRoutes(cleaning = true) {
            this.routeLegs.forEach(leg => {
                if (leg.polyline) leg.polyline.setMap(null);
                else leg.setMap(null);
            });
            if(cleaning) this.routeLegs.clear();
        },
        getRouteInfo(p1, p2) {
            return this.routeLegs.get(p1.id + "-" + p2.id);
        },
        showLeg(id, points, color = 'blue') {
            let routeId = id.split('-') ? id.split('-')[0] : id;
            let leg = this.routeLegs.get(id);

            if (!color) color = this.colorScheme.get('route-' + routeId);
            if (!color) {
                color = 'rgb(' + rand(0, 256) + ',' + rand(0, 256) + ',' + rand(0, 256) + ')';
                this.colorScheme.set('route-' + routeId, color);
            }

            if (!leg) {
                let polyline = new google.maps.Polyline({
                    path: points,
                    strokeColor: color,
                    strokeOpacity: 0.8,
                    strokeWeight: 6,
                    map: this.map
                });

                this.routeLegs.set(id, polyline);
            } else {
                leg.setMap(this.map);
            }
        },
        hideLeg(id) {
            let leg = this.routeLegs.get(id);
            if (leg) leg.setMap(null);
        },
        setRoute(p1, p2, callback = null, component = null) {
            const self = this;

            function sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }

            let leg = this.routeLegs.get(p1.id + "-" + p2.id);
            ////console.log("leg", p1.id + "-" + p2.id);
            if (!leg) {
                this.gds.route({
                    origin: this.markers.get(p1).position,
                    destination: this.markers.get(p2).position,
                    optimizeWaypoints: false,
                    travelMode: 'DRIVING',
                    avoidFerries: true,
                }, function (response, status) {
                    ////console.log(response);
                    // self.gdr.setDirections(response);
                    let points = [];
                    let route = response.routes[0].legs[0];

                    for (var i = 0; i < route.steps.length; i++) {
                        for (var j = 0; j < route.steps[i].lat_lngs.length; j++) {
                            points.push(route.steps[i].lat_lngs[j]);
                        }
                    }



                    leg = self.routeLegs.get(p1.id + "-" + p2.id);
                    if (!leg) {
                        let polyline = new google.maps.Polyline({
                            path: points,
                            strokeColor: 'blue',
                            strokeOpacity: 0.5,
                            strokeWeight: 6,
                            map: self.map
                        });

                        // google.maps.event.addListener(polyline, 'mouseover', function (e) {
                        //     self.iw.setPosition(e.latLng);
                        //     self.iw.setContent("Дистанция: " + route.distance.text + "<br>" + "Время: " + route.duration.text + "<br>");
                        //     self.iw.open(self.map);
                        // });

                        // google.maps.event.addListener(polyline, 'mouseout', function () {
                        //     self.iw.close();
                        // });

                        self.routeLegs.set(p1.id + "-" + p2.id, { polyline, route, leg: points });
                        if (callback) callback({ polyline, route, leg: points }, component);
                    }

                    // let prevPath = null;
                    // for (var i = 0; i < response.routes[0].overview_path.length; i++) {
                    //     let target = response.routes[0].overview_path[i];
                    //     if (prevPath) {
                    //         new google.maps.Polyline({
                    //             path: [prevPath, target],
                    //             strokeColor: 'blue',
                    //             strokeOpacity: 1.0,
                    //             strokeWeight: 3,
                    //             map: self.map
                    //         });
                    //     }
                    //     prevPath = target;
                    // }
                });
            } else {
                if (leg.polyline) leg.polyline.setMap(this.map);
                else leg.setMap(this.map);

                if (callback) callback({ polyline: leg.polyline, route: leg.route, leg: leg.leg }, component);
            }
        },
        geocode(value, type = "latLng") {
            const self = this;
            if(type == "latLng"){
                return new Promise(resolve => {
                    this.geocoder.geocode({
                        latLng: value
                    }, function (responses) {
                        ////console.log(responses);
                        if (responses && responses.length > 0) {
                            resolve(responses[0].formatted_address);
                        } else {
                            resolve(false);
                        }
                    });
                })
            } else if(type == "address"){
                return new Promise(resolve => {
                    this.geocoder.geocode({
                        address: value
                    }, function (responses,status) {
                        ////console.log(responses);
                        if (responses && responses.length > 0) {
                            resolve(responses[0].geometry.location);
                        } else {
                            resolve(false);
                        }
                    });
                })
            }
        },
        fitBounds(points) {
            let bounds = new google.maps.LatLngBounds();

            points.map(point => {
                let marker = this.markers.get(point);
                if (marker) bounds.extend(marker.position);
            });

            this.map.fitBounds(bounds);
        },
        showRoute(points) {

            const self = this;
            let waypts = [];

            for (var i = 1; i < points.length - 1; i++) {
                waypts.push({
                    location: this.markers.get(points[i]).position,
                    stopover: true
                });
            }


            this.gds.route({
                origin: this.markers.get(points[0]).position,
                destination: this.markers.get(points[points.length - 1]).position,
                waypoints: waypts,
                optimizeWaypoints: false,
                travelMode: 'DRIVING'
            }, function (response, status) {
                self.gdr.setDirections(response);
                // let prevPath = null;
                // for (var i = 0; i < response.routes[0].overview_path.length; i++) {
                //     let target = response.routes[0].overview_path[i];
                //     if (prevPath) {
                //         new google.maps.Polyline({
                //             path: [prevPath, target],
                //             strokeColor: 'blue',
                //             strokeOpacity: 1.0,
                //             strokeWeight: 3,
                //             map: self.map
                //         });
                //     }
                //     prevPath = target;
                // }
            })
        },
        closeInfoWindow() {
            this.iw.close();
        },
        optimize(points) {
            var self = this;

            let x, y, min = {
                x: Infinity,
                y: Infinity
            };
            var po_points = points.map(point => {
                return new this.pathOptimizer.Point(point.lat, point.lon, point);
            })
            var solution = this.pathOptimizer.solve(po_points, 0.9999);

            return solution;
            // var path = [];
            // points.map(point => {
            //     path[point.index - 1] = point;
            // })

            // let first, last, waypts = [];
            // solution.map((order, index) => {
            //     if (!first) {
            //         first = this.markers.get(po_points[order.index].data).position;
            //         return;
            //     }
            //     if (!last && index == solution.length - 1) {
            //         last = this.markers.get(po_points[order.index].data).position;
            //         return;
            //     }

            //     waypts.push({
            //         location: this.markers.get(po_points[order.index].data).position,
            //         stopover: true
            //     });
            // });
            // ////console.log({ po_points, solution });

            // function sleep(ms) {
            //     return new Promise(resolve => setTimeout(resolve, ms));
            // }

            // this.gds.route({
            //     origin: first,
            //     destination: last,
            //     waypoints: waypts,
            //     optimizeWaypoints: false,
            //     travelMode: 'DRIVING'
            // }, async function (response, status) {
            //     ////console.log(response, status);
            //     let prevPath = null;
            //     for (var i = 0; i < response.routes[0].overview_path.length; i++) {
            //         await sleep(10);
            //         let target = response.routes[0].overview_path[i];
            //         if (prevPath) {
            //             new google.maps.Polyline({
            //                 path: [prevPath, target],
            //                 strokeColor: 'rgb(' + red + ',' + green + ',' + blue + ')',
            //                 strokeOpacity: 1.0,
            //                 strokeWeight: 3,
            //                 map: self.map
            //             });
            //         }
            //         red += 0.2;
            //         green -= 0.3;
            //         blue -= 0.3;

            //         prevPath = target;
            //     }
            //     // if (status == 'OK') {
            //     //     self.gdr.setDirections(result);
            //     // }
            // });
        },
        getDirectionService() { return this.gds; },
        getDirectionRenderer() { return this.gdr; },
        getMarkers() { return this.markers; },
        refreshPointsIndex(points) {
            return points.map((item, idx) => {
                item.index = idx + 1;
                return item;
            });
        },
        rad(x) {
            return x * Math.PI / 180;  
        },
        getRadDistance(q,p) {
            var dLat = this.rad(q.lat - p.lat);
            var dLon = this.rad(q.lon - p.lon);
            var lat1 = this.rad(p.lat);
            var lat2 = this.rad(q.lat);

            var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
            var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            var d = R * c;
            return d;
        },
        fastRoute(points, optimize, circle) {
            let self = this;

            return new Promise((resolve,reject) => {
                let pointsArr = points.sort((a, b) => {
                    return a.index - b.index;
                });

                let waypoints = [];
                let distance = 0;
                let duration = 0;

                if (pointsArr[0].address !== null && pointsArr[pointsArr.length - 1].address !== null) {
                    let start = new google.maps.LatLng(pointsArr[0].lat, pointsArr[0].lon);
                    let finish = new google.maps.LatLng(pointsArr[pointsArr.length - 1].lat, pointsArr[pointsArr.length - 1].lon);

                    let destination = finish;
                    let destinationIndex = pointsArr.length - 1;

                    if(circle){
                        destination = start;
                    } 

                    if(optimize) {
                        if(!circle) {
                            let max = 0;

                            for(var i = 1; i < pointsArr.length; i++){
                                let d = this.getRadDistance(pointsArr[0], pointsArr[i]);
                                if(d > max){
                                    max = d;
                                    destination = new google.maps.LatLng(pointsArr[i].lat, pointsArr[i].lon);
                                    destinationIndex = i;
                                }
                            }
                        }
                    }

                    pointsArr.map( (p, idx) => {
                        if (idx !== 0) {
                            waypoints.push({
                                location: new google.maps.LatLng(p.lat, p.lon),
                                stopover: true
                            });
                        };
                    });

                    this.gds.route({
                        origin: start,
                        destination: destination,
                        waypoints: waypoints,
                        travelMode: google.maps.TravelMode.DRIVING,
                        optimizeWaypoints: optimize,
                        avoidFerries: true,
                    }, (result, status) => {
                        if(status == 'OK') {
                            let legs = [];
                            let route = null;

                            result.routes[0].legs.map(leg => {
                                distance += leg.distance.value;
                                duration += leg.duration.value;

                                let steps = [];
                                for (var i = 0; i < leg.steps.length; i++) {
                                    for (var j = 0; j < leg.steps[i].lat_lngs.length; j++) {
                                        steps.push(leg.steps[i].lat_lngs[j]);
                                    }
                                }

                                legs.push(steps);
                            });

                            self.gdr.setDirections(result);
                            self.gdr.setMap(self.map);

                            if(optimize){
                                route = [pointsArr[0]];

                                result.routes[0].waypoint_order.map(order => {
                                    route.push(pointsArr[order + 1]);
                                });
                            }

                            resolve({ legs, route, distance, duration});
                        } else {
                            reject(false);
                        }
                    });
                }
            });
        }
    };

    return mapHelper;

})));